<template>
	<div>
		<v-layout wrap justify-end pr-4 v-if="!!this.codeBooking">
			<v-flex xs3 pl-2>
				<v-btn
					class="btn-save btn-success"
					@click="goToCheckIn"
				>
					Editar huéspedes adicionales
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap pr-4 justify-space-between>
			<v-flex xs12 md4 pr-5>
				<v-select
					class="filter-select filter-select-main"
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					label="Sucursales"
					v-model="subsidiaryId"
					hide-details
					:disabled="!!codeBooking"
					@input="loadTypeRooms"
					single-line
					bottom>
				</v-select>
			</v-flex>
			<v-flex xs12 md6 text-xs-right>
				<h5
					class="code-number"
					v-if="booking && booking.code"
				>
					Nº Reserva: {{ booking.numReservation }}
				</h5>
			</v-flex>
		</v-layout>
		<v-layout wrap v-if="!!codeBooking">
			<v-flex xs12>
				<div class="bar-data">
					<div class="bar-data-item">
						<p>
							Llegada:
							<span>{{ booking.bookingStart | parseDate }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Salida:
							<span>{{ booking.bookingEnd | parseDate }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Noches:
							<span>{{ booking.numberNights }}</span>
						</p>
					</div>
					<div
						v-if="multiRooms"
						class="bar-data-item"
					>
						<p>
							Tipo Hab.:
							<span>{{ booking.room.data.roomTypes.data.name }}</span>
						</p>
					</div>
					<div
						v-if="multiRooms"
						class="bar-data-item"
					>
						<p>
							Nº Hab.:
							<span>{{ booking.room.data.codeRoom }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Nº Huésped:
							<span>{{ booking.summary.booking.guestsNumber }}</span>
						</p>
					</div>
					<div class="bar-data-item">
						<p>
							Por Noche:
							<span>
								{{ booking.summary.promotion.currency }}
								{{ booking.ratePerDay }}
							</span>
						</p>
					</div>
					<div class="bar-data-item no-border">
						<p>
							Total:
							<span>
								{{ booking.summary.promotion.currency }}
								{{ booking.bookingTotal }}
							</span>
						</p>
					</div>
				</div>
			</v-flex>
		</v-layout>
		<v-layout
			row wrap
			v-for="(booking, bookingIndex) in bookings"
			:key="bookingIndex">
			<v-flex px-1 xs12>
				<rooms-component
					v-for="(bookingRoom, indexBookingRoom) in booking.rooms"
					:key="indexBookingRoom"
					:index="indexBookingRoom"
					:type-rooms="typeRooms"
					:booking="bookingRoom"
					:rooms="bookingRoom.availableRooms"
					:currencies="currencies"
					:pre-payment="prepaymentDisabled"
					:id-subsidiary="subsidiaryId"
					:multiple-bookings="multipleBookings"
					:code-booking="!!codeBooking"
					@load-free-rooms="loadFreeRooms($event, bookingIndex, indexBookingRoom)"
					@load-rate="loadRate($event, bookingIndex, indexBookingRoom)"
					@total-by-booking="updateTotalByBooking($event, bookingIndex, indexBookingRoom)"
					@delete-booking="deleteBooking"
					@edit-reservations="editReservation($event, bookingIndex)"
				/>
			</v-flex>
			<v-flex xs12>
				<v-layout wrap align-center>
					<v-flex xs2 text-xs-left>
						<label class="label-form small">Código</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							:disabled="prepaymentDisabled"
							v-model="booking.numReservation"
							@keyup="validateNumReservation(booking)">
						</v-text-field>
						<span class="caption red--text"
							v-if="!validateNumReservation(booking)">
							El código debe contener una barra lateral (/) entre sus dígitos.
						</span>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap mt-3
			justify-space-between
			align-center>
			<v-flex xs12 md9>
				<v-checkbox
					class="input-checkbox input-booking"
					label="IGV - Los huéspedes extranjeros (no residentes) estarán exentos de impuestos"
					v-model="model.flagTaxes"
					color="info"
					:disabled="prepaymentDisabled"
					hide-details>
				</v-checkbox>
			</v-flex>
			<v-flex xs12 md3>
				<v-layout row wrap align-center
					class="total-amount">
					<v-flex xs3 text-xs-right>
						<p>Subtotal:</p>
					</v-flex>
					<v-flex xs9>
						<p>${{ subtotalAmount | round }}</p>
					</v-flex>
				</v-layout>
				<v-layout row wrap align-center
					class="total-amount">
					<v-flex xs3 text-xs-right>
						<p>IGV:</p>
					</v-flex>
					<v-flex xs9>
						<p>${{ taxesAmount | round }}</p>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs6 md3>
				<button-create
					v-if="showAditionalBook && !codeBooking"
					text="Reserva Adicional"
					btn-function
					@function-click="addBookingRow"
					:disabled="disabledBtnCreate"
				>
				</button-create>
			</v-flex>
			<v-flex xs6 md3>
				<v-layout row wrap align-center
					class="total-amount">
					<v-flex xs3 text-xs-right>
						<p>Total:</p>
					</v-flex>
					<v-flex xs9>
						<span>${{ totalAmount | round }}</span>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap my-3>
			<v-divider></v-divider>
		</v-layout>
		<v-layout wrap>
			<v-flex xs12>
				<v-checkbox
					class="input-checkbox input-booking generic-checkbox"
					label="Cliente Genérico"
					v-model="model.flagGeneric"
					color="info"
					v-tooltip:right="{ html: 'Usar esta opción cuando no se tenga el documento del huésped.' }"
					hide-details>
				</v-checkbox>
			</v-flex>
		</v-layout>
		<v-layout wrap v-if="genericCustomer">
			<v-flex xs12 text-xs-left mb-2>
				<label class="label-title">Completa los datos</label>
			</v-flex>
			<v-flex xs12 text-xs-left>
				<label class="label-form">Nº de Tarjeta</label>
			</v-flex>
			<v-flex xs3>
				<v-select
					autocomplete
					class="filter-select filter-select-autocomplete filter-select-indicator"
					item-text="name"
					item-value="id"
					:items="typeCards"
					v-model="typeCard"
					hide-details
					single-line
					bottom>
				</v-select>
				<v-text-field
					type="text"
					class="input-border-inset input-form-select"
					v-model="model.cardVip">
				</v-text-field>
			</v-flex>
		</v-layout>
		<v-layout>
			<v-flex xs12 text-xs-left>
				<v-layout row>
					<v-flex xs3 mb-3>
						<label class="label-form">Tipo de identificación</label>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete filter-select-indicator"
							item-text="code"
							item-value="id"
							:items="typeDocuments"
							v-model="model.documentType"
							hide-details
							single-line
							bottom>
						</v-select>
						<v-text-field
							type="text"
							class="input-border-inset input-form-select"
							@blur="searchCustomer"
							v-model="model.numDocument">
						</v-text-field>
						<span class="caption red--text"
							v-if="$v.model.numDocument && $v.model.numDocument.$invalid">
							El número de documento es requerido
						</span>
						<p class="caption red--text mb-0"
							v-if="$v.model.numDocument && $v.model.numDocument.$invalid
								&& $v.model.numDocument.$params.minLength">
							Es necesario ingresar {{ $v.model.numDocument.$params.minLength.min }} dígitos
						</p>
					</v-flex>
					<v-flex xs3 mb-3 :class="{ 'xs6' : !isNaturalPerson }">
						<label class="label-form">{{ nameLabel }}</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							:disabled="!model.numDocument"
							v-model="model.name">
						</v-text-field>
						<span class="caption red--text"
							v-if="$v.model.name && $v.model.name.$invalid">
							{{ nameMessage }}
						</span>
					</v-flex>
					<v-flex xs3 mb-3 v-if="isNaturalPerson">
						<label class="label-form">Apellidos</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							placeholder="Completos"
							:disabled="!model.numDocument"
							v-model="model.lastname">
						</v-text-field>
						<span class="caption red--text"
							v-if="$v.model.lastname && $v.model.lastname.$invalid">
							El apellido es requerido
						</span>
					</v-flex>
					<v-flex xs3 mb-3>
						<label class="label-form">Correo electrónico</label>
						<v-text-field
							type="email"
							class="input-border-inset"
							placeholder="nombre@mail.com"
							:disabled="!model.numDocument"
							v-model="model.email">
						</v-text-field>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-if="genericCustomer">
					<v-flex xs3 mb-3>
						<label class="label-form">Fecha de nacimiento</label>
						<v-layout row wrap>
							<v-flex xs4 pa-0>
								<v-text-field
									class="input-regular input-label-select"
									value="Adulto"
									hide-details
									readonly>
								</v-text-field>
							</v-flex>
							<v-flex xs8 py-0 pl-0>
								<v-menu
									lazy
									v-model="menuBirthDate"
									transition="scale-transition"
									offset-y
									full-width
									class="menu-date-picker"
									:disabled="!model.numDocument"
									max-width="290px"
									@input="changeIcon">
									<v-text-field
										slot="activator"
										label="Fecha de nacimiento"
										v-model="model.dateBirth"
										:append-icon="arrowIcon(birthDateIcon)"
										single-line
										hide-details
										readonly
									></v-text-field>
									<v-date-picker
										v-model="model.dateBirth"
										locale="es-PE"
										year-icon
										scrollable>
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs3 mb-3 v-if="isNaturalPerson">
						<label class="label-form">Estado civil</label>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete"
							item-text="name"
							item-value="id"
							:items="civilStatus"
							v-model="model.civilStatus"
							hide-details
							:disabled="!model.numDocument"
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3 mb-3 v-if="isNaturalPerson">
						<label class="label-form">Género</label>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete"
							item-text="name"
							item-value="id"
							:items="genders"
							v-model="model.gender"
							hide-details
							:disabled="!model.numDocument"
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">País</label>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete"
							:items="countries"
							item-text="name"
							item-value="id"
							label="Elige el país"
							v-model="model.countryId"
							hide-details
							:disabled="!model.numDocument"
							single-line
							@input="loadCities"
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3>
						<label class="label-form">Ciudad</label>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete"
							:items="citiesByCountry"
							item-text="province"
							item-value="id"
							v-model="model.cityId"
							hide-details
							:disabled="!model.numDocument"
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs3 mb-3>
						<label class="label-form">Teléfono</label>
						<v-text-field
							type="number"
							class="input-border-inset"
							:disabled="!model.numDocument"
							v-model="model.phone">
						</v-text-field>
					</v-flex>
					<v-flex xs6 mb-3>
						<label class="label-form">Dirección</label>
						<v-text-field
							type="text"
							class="input-border-inset"
							:disabled="!model.numDocument"
							v-model="model.address">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap my-3>
			<v-divider></v-divider>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 text-xs-left mb-2>
				<label class="label-title">Canal de Reserva</label>
			</v-flex>
			<v-flex xs12 md2 text-xs-left mb-3>
				<select-button
					class="txt-xs-left"
					label-text="Seleccionar vendedor"
					item-text="name"
					item-value="id"
					:items="sellers"
					v-model="sellerId"
				/>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap align-center>
					<v-flex xs4 md3>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete"
							:items="typeChannels"
							item-text="name"
							item-value="id"
							label="Tipo de Canal"
							v-model="typeChannelId"
							hide-details
							@input="loadChannels"
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs4 md3>
						<v-select
							autocomplete
							class="filter-select filter-select-autocomplete"
							:items="channels"
							item-text="inputSearch"
							item-value="id"
							label="Canal"
							v-model="channelSelected"
							hide-details
							single-line
							@input="setChannelInfo"
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs2 v-if="flagBooking" class="customer-rate">
						<v-btn
							class="btn-save mt-0"
							@click="onShowRateModal"
						>Tarifario</v-btn>
						<transition name="slide-fade">
							<rate-modal
								v-if="flagShowRateModal"
								class="rate-modal"
								:subsidiary-id="subsidiaryId"
								:rates="rateAvailability"
								@update-customer-rate="updateCustomerRate"
								@subsidiary-select="showCustomerRate"
							/>
						</transition>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap mt-2>
					<v-flex xs4 md3
						v-for="(field, fieldIndex) in typeChannelSelected.fields"
						:key="fieldIndex"
						text-xs-left>
						<label class="label-form">{{ field.label }}</label>
						<component
							:is="field.type"
							:item-text="field.items.itemText"
							:item-value="field.items.itemValue"
							:items="field.items.name"
							:autocomplete="field.type === 'v-select'"
							:class="{ 'filter-select filter-select-autocomplete':
								field.type === 'v-select',
								'input-border-inset': field.type === 'v-text-field' }"
							v-model="field[field.value]">
						</component>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap my-3>
			<v-divider></v-divider>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs8>
				<v-layout row wrap
					text-xs-left>
					<v-flex xs4>
						<label class="label-text">Late Check Out</label>
					</v-flex>
					<v-flex xs4>
						<label class="label-text">Late Check Out</label>
					</v-flex>
					<v-flex xs4>
						<label class="label-text">Late Check Out</label>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs4
				v-if="lateCheckOutIsSelected">
				<v-layout row wrap
					text-xs-left>
					<v-flex xs6>
						<label class="label-form">Hora</label>
					</v-flex>
					<v-flex xs6>
						<label class="label-form">Precio</label>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs8>
				<v-radio-group
					v-model="lateCheckOut"
					class="radio-check-group"
					row>
					<v-radio
						v-for="late in arrayLate"
						:key="late.id"
						:disabled="lateCheckOutDisabled"
						:label="`${late.hour} - $${late.price}`"
						:value="late"
					>
					</v-radio>
				</v-radio-group>
			</v-flex>
			<v-flex xs4
				v-if="lateCheckOutIsSelected">
				<v-layout row wrap>
					<v-flex xs6>
						<v-text-field
							type="text"
							class="input-border-inset"
							:readonly="lateCheckOutDisabled"
							v-model="lateCheckOut.hour">
						</v-text-field>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							type="text"
							class="input-border-inset"
							:readonly="lateCheckOutDisabled"
							v-model="lateCheckOut.price">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs8>
				<v-layout row wrap
					text-xs-left>
					<v-flex xs4>
						<label class="label-text">Early Check In</label>
					</v-flex>
					<v-flex xs4>
						<label class="label-text">Early Check In</label>
					</v-flex>
					<v-flex xs4>
						<label class="label-text">Early Check In</label>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs4
				v-if="earlyCheckInIsSelected">
				<v-layout row wrap
					text-xs-left>
					<v-flex xs6>
						<label class="label-form">Hora</label>
					</v-flex>
					<v-flex xs6>
						<label class="label-form">Precio</label>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs8>
				<v-radio-group
					v-model="earlyCheckIn"
					class="radio-check-group"
					row>
					<v-radio
						v-for="early in arrayEarly"
						:key="early.id"
						:disabled="earlyCheckinDisabled"
						:label="`${early.hour} - $${early.price}`"
						:value="early"
					>
					</v-radio>
				</v-radio-group>
			</v-flex>
			<v-flex xs4
				v-if="earlyCheckInIsSelected">
				<v-layout row wrap>
					<v-flex xs6>
						<v-text-field
							type="text"
							class="input-border-inset"
							:readonly="earlyCheckinDisabled"
							v-model="earlyCheckIn.hour">
						</v-text-field>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							type="text"
							class="input-border-inset"
							:readonly="earlyCheckinDisabled"
							v-model="earlyCheckIn.price">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs8 text-xs-left>
				<v-flex xs8>
					<button-field
						label-text="Cama adicional"
						:activated-button="bedSelected"
						:block-button="disabledBed"
						v-model="aditionalBedPrice"
						@activate-button="selectBed"
					/>
				</v-flex>
			</v-flex>
			<v-flex xs8 text-xs-left>
				<v-flex xs8>
					<button-field
						label-text="Cuna"
						:activated-button="cribSelected"
						:block-button="disabledCrib"
						v-model="cribPrice"
						@activate-button="selectCrib"
					/>
				</v-flex>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 text-xs-left>
				<label class="label-form">Observaciones del huésped</label>
			</v-flex>
			<v-flex xs12>
				<v-text-field
					class="input-border-inset input-textarea input-note mt-1"
					no-resize
					multi-line
					placeholder="Escriba aquí"
					:rows="7"
					textarea
					v-model="specialRequest"
				></v-text-field>
			</v-flex>
			<v-flex xs3 mt-3>
				<v-checkbox
					v-show="showCheckLoyalty"
					class="input-checkbox input-booking"
					label="Activar los puntos LOYALTY"
					v-model="model.flagLoyalty"
					:disabled="!model.email"
					color="info"
					hide-details>
				</v-checkbox>
			</v-flex>
			<v-flex xs9 mt-3>
				<v-layout row wrap justify-end>
					<v-flex xs3
						v-show="checkinActive">
						<v-checkbox
							class="input-checkbox input-booking"
							label="Check-in Automático"
							v-model="flagCheckIn"
							color="info"
							hide-details>
						</v-checkbox>
					</v-flex>
					<v-flex xs2 pl-0>
						<v-btn
							class="btn-save"
							:disabled="bookingDisabled"
							@click="createBooking">
							{{ btnText }}
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-dialog
			v-if="roomsModalOpen"
			v-model="roomsModalOpen"
			width="fit-content"
		>
			<v-card>
				<v-card-text>
					<v-layout row wrap mb-3>
						<v-flex xs6 md2>
							<select-date
								disabled
								placeholder="Fecha de inicio"
								icon="event"
								:allowed-dates="(date) => isAfterMethod(date, subDaysMethod(new Date(), 2))"
								:value="formattingDate(booking.bookingStart)"
							/>
						</v-flex>
						<v-flex xs6 md2>
							<select-date
								disabled
								placeholder="Fecha de fin"
								:allowed-dates="(date) => isAfterMethod(date, booking.bookingStart)"
								:value="formattingDate(booking.bookingEnd)"
							/>
						</v-flex>
					</v-layout>
					<date-header
						:init-day="headerDates.initDate"
						:end-day="headerDates.endDate"
					/>
					<select-room-number
						v-for="(reserve, indexReserve) in roomsByDay"
						:key="indexReserve"
						:reservation-index="indexReserve"
						:types-rooms="typeRooms"
						:subsidiary="subsidiaryId"
						:rooms-by-day="reserve"
						:rates="ratesByDayAndRoomType"
						:all-reservation="roomsByDay"
						@update-rooms-selected-data="updateRoomsSelected"
						@update-reservation="updateRatesInReservation"
					/>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-layout row justify-center>
						<v-flex xs2 mr-4>
							<v-btn
								class="mr-0 success"
								@click="updateReservation(roomsByDay)"
							>
								Aceptar
							</v-btn>
						</v-flex>
						<v-flex xs2>
							<v-btn
								class="mr-0 cancel"
								@click="closeModal(false)"
							>
								Cancelar
							</v-btn>
						</v-flex>
					</v-layout>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import { maxLength, minLength, requiredIf } from 'vuelidate/lib/validators';
	import {
		isBefore,
		isWithinRange,
		differenceInDays,
		format,
		isDate,
		subDays,
		subYears,
		addDays,
		} from 'date-fns';
	import ButtonCreate from '@/components/shared/ButtonCreate';
	import mixin from '@/shared/mixins';
	import { parseDate, round } from '@/shared/filters';
	import lib from '@/shared/lib';
	import helper from '@/shared/helper';
	import roomsComponent from '@/clerkinn/bookings/sub-component/rooms-component';
	import SelectRoomNumber from '@/clerkinn/shared/SelectRoomNumber';
	import DateHeader from '@/clerkinn/shared/DateHeader';
	import SelectDate from '@/clerkinn/shared/select-date';
	import selectButton from '@/clerkinn/shared/select-button';
	import ButtonField from '@/clerkinn/shared/ButtonField';
	import rateModal from './sub-component/RateModal';

	const { formatDate } = helper.methods;
	const FLAG_RATE = 0;
	const {
		compose,
		createPropertyByOtherOne,
		find,
		equality,
		getDeeper,
		getDeepPropertyOf,
		getIndexOf,
		map,
		reduce,
		setNewProperty,
		setNewPropertyByFunction,
		} = lib;

	function created() {
		this.loadResources();
	}

	function addBookingRow() {
		const len = this.bookings.length;
		const newBooking = {
			id: len + 1,
			adults: 0,
			checkIn: null,
			checkOut: null,
			childs: 0,
			currency: 'USD',
			entityId: 0,
			iconUpEnd: false,
			iconUpStart: false,
			idRoom: 0,
			maxQuantity: 0,
			menuEnd: false,
			menuStart: false,
			numberNights: 0,
			numReservation: '',
			rate: 0,
			ratesByDayAndRoomType: {},
			rooms: [
				{
					availableRooms: [],
					idRoom: 0,
					entityId: 0,
				},
			],
			total: 0,
		};
		this.bookings = this.bookings.concat(newBooking);
		this.bookings[len].rooms[0] = this.setBookingsData(
					this.$route.query,
					this.bookings[len].rooms[0],
				);
	}

	function arrowIcon(iconUp) {
		const arrow = iconUp ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function btnText() {
		return this.codeBooking ? 'Actualizar' : 'Reservar';
	}

	function bookingDisabled() {
		const invalid = this.bookings.some(b => b.invalid);
		return this.$v.$invalid || this.channelEmpty || invalid || this.disabledBtnCreate;
	}

	function changeFormatDate(value) {
		return new Date(value).toISOString().substr(0, 10);
	}

	function changeIcon({ id }, type) {
		if (type) {
			this.bookings = this.bookings.map((booking) => {
				const newBooking = { ...booking };
				if (booking.id === id) {
					newBooking[`iconUp${type}`] = booking[`menu${type}`];
				}
				return newBooking;
			});
		} else {
			this.birthDateIcon = this.menuBirthDate;
		}
	}

	function channelEmpty() {
		return !this.typeChannelId;
	}

	function getBookingData(prop, obj) {
		return function inner(item) {
			if (obj) {
				return obj[prop];
			}
			return item[prop];
		};
	}

	function basicReservationCreate(bookingsData, subsidiaryId) {
		const roomsData = bookingsData.rooms;
		return map(
			compose(
				setNewPropertyByFunction('adults', getBookingData('adults')),
				setNewPropertyByFunction('checkIn', getBookingData('checkIn')),
				setNewPropertyByFunction('checkOut', getBookingData('checkOut')),
				setNewPropertyByFunction('childs', getBookingData('childs')),
				setNewPropertyByFunction('currency', getBookingData('currency')),
				setNewPropertyByFunction('entityId', getBookingData('entityId')),
				setNewPropertyByFunction('idRoom', getBookingData('idRoom')),
				setNewPropertyByFunction('maxQuantity', getBookingData('maxQuantity')),
				setNewPropertyByFunction('numberNights', getBookingData('numberNights')),
				setNewPropertyByFunction('rate', getBookingData('rate')),
				setNewPropertyByFunction('total', getBookingData('total')),
				setNewPropertyByFunction('iconUpEnd', getBookingData('iconUpEnd', bookingsData)),
				setNewPropertyByFunction('iconUpStart', getBookingData('iconUpStart', bookingsData)),
				setNewPropertyByFunction('menuEnd', getBookingData('menuEnd', bookingsData)),
				setNewPropertyByFunction('menuStart', getBookingData('menuStart', bookingsData)),
				setNewPropertyByFunction('numReservation', getBookingData('numReservation', bookingsData)),
				setNewPropertyByFunction('invalid', getBookingData('invalid', bookingsData)),
				setNewProperty('idSubsidiary', subsidiaryId),
			),
			roomsData,
		);
	}

	function basicReservationEdit(bookingsData, body, subsidiaryId) {
		const checkIn = bookingsData.rooms[0].checkIn;
		const len = bookingsData.rooms.length;
		const checkOut = bookingsData.rooms[len - 1].checkOut;
		return compose(
			setNewProperty('adults', bookingsData.rooms[0].adults),
			setNewProperty('checkIn', checkIn),
			setNewProperty('checkOut', checkOut),
			setNewProperty('childs', bookingsData.rooms[0].childs),
			setNewProperty('entityId', bookingsData.rooms[0].entityId),
			setNewProperty('rate', bookingsData.rooms[0].rate),
			setNewProperty('numReservation', bookingsData.numReservation || null),
			setNewProperty('idSubsidiary', subsidiaryId),
		)(body);
	}

	function simpleReservation(bookinsData, body) {
		return setNewProperty('idRoom', bookinsData.rooms[0].idRoom)(body);
	}

	function updateFinalRooms() {
		return function inner(item) {
			const { checkIn, checkOut, idRoom, entityId, rate } = item;
			const dateInit = format(checkIn, 'YYYY-MM-DD');
			const dateEnd = format(checkOut, 'YYYY-MM-DD');
			return compose(
				setNewProperty('idRoom', idRoom),
				setNewProperty('entityId', entityId),
				setNewProperty('rate', rate),
				setNewProperty('dateEnd', dateEnd),
				setNewProperty('dateInit', dateInit),
			)({});
		};
	}

	function multipleReservation(bookingData, body) {
		const finalRooms = map(
			updateFinalRooms(),
			bookingData,
		);
		return setNewProperty('rooms', finalRooms)(body);
	}

	async function createBooking() {
		const isMultipleRooms = this.bookings[0].rooms.length > 1;
		const flagMultipleRooms = this.booking.summary.bookingRooms;
		const codeBooking = this.codeBooking;
		const indexSub = this.subsidiaries.findIndex(element => element.id === this.subsidiaryId);
		const channelInformation = {};
		const channelInformationValues = [];
		this.typeChannelSelected.fields.forEach((field) => {
			channelInformation[field.value] = field[field.value];
			if (field[field.value]) {
				channelInformationValues.push(field[field.value]);
			}
		});
		let bookingData = {
			address: this.model.address,
			cardVip: this.model.cardVip,
			channelId: this.typeChannelId,
			channelSelected: channelInformationValues.length > 0 ? this.channelSelected : null,
			cityId: this.model.cityId,
			civilStatus: this.model.civilStatus,
			countryId: this.model.countryId,
			dateBirth: this.model.dateBirth,
			documentType: this.model.documentType,
			email: this.model.email,
			flagLoyalty: this.model.flagLoyalty,
			gender: this.model.gender,
			id: this.genericCustomer ? this.model.id : null,
			lastname: this.model.lastname,
			name: this.model.name,
			numDocument: this.model.numDocument,
			flagTaxes: this.model.flagTaxes,
			flagGeneric: this.model.flagGeneric,
			phone: this.model.phone,
			website: window.location.origin,
			specialRequest: this.specialRequest,
			hotelName: this.subsidiaries[indexSub].name,
			sellerId: this.sellerId,
			extraBed: this.bedSelected ? this.getExtraBed(this.aditionalBedPrice) : null,
			addCrib: this.cribSelected ? this.getCrib(this.cribPrice) : null,
			earlyCheckin: this.earlyCheckIn || null,
			lateCheckout: this.lateCheckOut || null,
		};
		if (bookingData.channelSelected >= 0) {
			bookingData.channelInformation = channelInformation;
		}
		if (codeBooking) {
			bookingData = this.basicReservationEdit(this.bookings[0], bookingData, this.subsidiaryId);
			if (isMultipleRooms || flagMultipleRooms) {
				const bookings = this.breakItByDay(this.bookings[0]);
				bookingData = this.multipleReservation(bookings, bookingData);
			} else {
				bookingData = this.simpleReservation(this.bookings[0], bookingData);
			}
		} else {
			bookingData.bookings = this.basicReservationCreate(this.bookings[0], this.subsidiaryId);
		}
		const method = codeBooking ? 'put' : 'post';
		let url = codeBooking ? `bookings/${codeBooking}` : 'bookings';
		url = isMultipleRooms || flagMultipleRooms ? `bookings-rooms/${codeBooking}` : url;
		const successMessage = codeBooking ? 'actualizó' : 'creó';
		try {
			await this.$http[method](`${process.env.PMS_URL}/${url}`, bookingData);
			this.showNotification(`La reserva se ${successMessage} correctamente.`, 'success');
			this.$router.push({ name: 'booking-list' });
		} catch (err) {
			if (err.status === 405) {
				if (err.data.message === '{"email":"El correo ya existe para el proyecto."}') {
					this.showNotification('El correo ya se encuentra registrado para recibir puntos LOYALTY.', 'error');
				}
				if (err.data.message === 'BOOKING_NOT_AVAILABLE_RANGE') {
					this.showNotification('La habitación no se encuentra disponible para las fechas seleccionadas.',
						'error');
				}
				if (err.data.message === 'BOOKING_CODE_EXISTS') {
					this.showNotification('El código ingresado ya existe.', 'error');
				}
			} else if (err.status === 400) {
				if (err.data.flagTaxes) {
					this.showNotification('No se está enviando la confirmación para aplicar o exonerar de impuestos.',
						'error');
				}
			} else if (err.status === 404) {
				if (err.data.message === 'PAYMENT_MADE_BOOKING') {
					this.showNotification('La reserva no puede ser editada porque cuenta con un pago adelantado.',
						'error');
				}
				if (err.data.code === 1031) {
					this.showNotification(
						'No es posible crear esta reservación, existe otra reserva con Late-Checkout. ',
						'error',
					);
				}
				if (err.data.message === 'BOOKING_NOT_AVAILABLE_RANGE') {
					this.showNotification('El tipo de habitación seleccionado no cuenta con disponibilidad para el rango de fechas seleccionado.',
						'error');
				}
			}
		}
	}

	function deleteBooking(index) {
		this.bookings.splice(index, 1);
	}

	function disabledBtnCreate() {
		let disabled = false;
		this.bookings.forEach((booking) => {
			Object.keys(booking).forEach(() => {
				disabled = (booking.adults + booking.childs) > booking.maxQuantity;
			});
		});
		return disabled;
	}

	function genericCustomer() {
		return !this.model.flagGeneric;
	}

	function goToCheckIn() {
		const params = {
			hotelId: this.subsidiaryId,
			roomTypeId: this.booking.entityId,
		};
		const query = {
			initDate: format(this.booking.bookingStart, 'YYYY-MM-DD'),
			endDate: format(this.booking.bookingEnd, 'YYYY-MM-DD'),
			roomId: this.booking.room.data.id,
			bookingCode: this.codeBooking,
		};
		this.$router.push({
			name: 'checkin-form-tabs',
			params,
			query,
		});
	}

	function isAfterMethod(date, dateToCompare) {
		return differenceInDays(date, dateToCompare) > 0;
	}

	function isNaturalPerson() {
		return this.model.documentType !== 4;
	}

	async function loadBookingData() {
		const codeBooking = this.codeBooking;
		const { data: booking } = await this.$http.get(`${process.env.PMS_URL}/bookings/${codeBooking}`);
		this.formatBooking(booking);
	}

	function formatBooking(booking) {
		const newBooking = { ...booking };
		newBooking.data.customer.data.flagGeneric = booking.data.customer.data.flagGeneric;
		newBooking.data.customer.data.countryId = booking.data.customer
			&& booking.data.customer.data.country ? booking.data.customer.data.country.data.id :
			process.env.DEFAULT_COUNTRY_ID;
		newBooking.data.customer.data.flagTaxes = booking.data.customer && booking.data.customer.data
			? booking.data.summary.personalInformation.flagTaxes : false;
		newBooking.data.summary.booking.guestsNumber = booking.data.summary
			&& booking.data.summary.booking ?
			booking.data.summary.booking.adults + booking.data.summary.booking.childrens : 0;
		newBooking.data.bookingTotal = booking.data.summary.personalInformation.flagTaxes ?
			booking.data.total : booking.data.summary.amounts.total;
		newBooking.data.ratePerDay = booking.data.summary.ratesPerDates ?
			booking.data.summary.ratesPerDates[0].price : 0;
		this.booking = newBooking.data;
		this.subsidiaryId = this.booking.summary.personalInformation.hotelId;
		this.typeChannelId = this.booking.channel ? this.booking.channel.data.id : 0;
		this.bookings[0].checkIn = format(this.booking.bookingStart, 'YYYY-MM-DD');
		this.bookings[0].checkOut = format(this.booking.bookingEnd, 'YYYY-MM-DD');
		this.bookings[0].numReservation = booking.data.numReservation;
		this.bookings[0].reservationId = booking.data.id;
		const flagGeneric = !!booking.data.customer.data.flagGeneric;
		this.model = flagGeneric
			? this.getSummaryData(booking, this.model, flagGeneric) : this.booking.customer.data;
		this.specialRequest = this.booking.summary.personalInformation.specialRequest;
		this.prepaymentDisabled = booking.data.summary.paymentBooking;
		if (this.prepaymentDisabled) {
			this.showNotification('Esta reserva tiene un pago adelantado', 'primary');
		}
		this.loadRateByDayAndType(
			formatDate(this.booking.bookingStart, 'YYYY-MM-DD'),
			formatDate(this.booking.bookingEnd, 'YYYY-MM-DD'),
		);
		this.checkForEarlyCheckInAndLateCheckOut(this.booking);
		if (this.booking.summary.services && this.booking.summary.services.length > 0) {
			const services = [...this.booking.summary.services];
			this.getServicesPrices(services);
		}
	}

	function calculateNumberNights(...args) {
		const [date2, date1] = args;
		return function inner(item) {
			const endDate = item[date2];
			const initDate = item[date1];
			return differenceInDays(endDate, initDate);
		};
	}

	function getSummary(prop, obj) {
		return function inner() {
			return obj.summary.booking[prop];
		};
	}

	function getRatePerDates(prop, obj) {
		return function inner(item, index) {
			if (prop) {
				let result = obj.summary.ratesPerDates[index][prop];
				result = prop === 'entityId' ? Number(result) : result;
				return result;
			}
			return obj.summary.ratesPerDates[index];
		};
	}

	function getTotalAmount() {
		return function inner(item) {
			return item.rate * item.numberNights;
		};
	}

	function buildRooms(roomsData, booking) {
		const newRooms = map(
			compose(
				setNewProperty('availableRooms', []),
				setNewPropertyByFunction('total', getTotalAmount(), false),
				setNewPropertyByFunction(
					'numberNights',
					calculateNumberNights('dateEnd', 'dateStart'),
				),
				createPropertyByOtherOne('checkIn', 'dateStart'),
				createPropertyByOtherOne('checkOut', 'dateEnd'),
				setNewPropertyByFunction('adults', getSummary('adults', booking)),
				setNewPropertyByFunction('childs', getSummary('childs', booking)),
				setNewPropertyByFunction('rate', getRatePerDates('price', booking)),
				setNewPropertyByFunction('currency', getRatePerDates('iso_currency', booking)),
				setNewPropertyByFunction('id', getDeepPropertyOf(booking, ['id'])),
				setNewPropertyByFunction('ratesPerDates', getRatePerDates(null, booking)),
				setNewPropertyByFunction('index', getIndexOf()),
			),
			roomsData,
		);
		return newRooms;
	}

	function getSummaryData(booking, model, flag) {
		const { personalInformation } = booking.data.summary;
		return compose(
			setNewProperty('flagGeneric', flag),
			setNewProperty('name', personalInformation.name),
			setNewProperty('lastname', personalInformation.lastName),
			setNewProperty('email', personalInformation.email),
			setNewProperty('numDocument', personalInformation.numDocument),
			setNewProperty('flagTaxes', personalInformation.flagTaxes),
		)(model);
	}

	async function loadChannels(id) {
		const typeSelected = this.typeChannels.find(type => type.id === id);
		this.typeChannelSelected.id = id;
		if (typeSelected.inputInformations && (typeSelected.inputInformations.length > 0)) {
			this.typeChannelSelected.fields = typeSelected.inputInformations.map((input) => {
				const newInput = { ...input };
				newInput[input.value] = '';
				if (!input.items) {
					newInput.items = [];
				} else {
					newInput.items.name = Object.assign([], this[input.items.name]);
				}
				return newInput;
			});
		}
		const { data: channel } = await this.$http.get(`${process.env.PMS_URL}/channel-informations/${id}`);
		this.channels = channel.data;
		this.channelSelected = 0;
		if (this.codeBooking) {
			this.channelSelected = this.booking.channel ?
				this.booking.channel.data.channelsInformationId : 0;
		}
	}

	async function loadCities(id) {
		this.model.cityId = 0;
		const params = { countryId: id };
		const { data: cities } = await this.$http.get(`${process.env.PMS_URL}/cities`, { params });
		if (this.model.city && this.model.city.data) {
			this.model.cityId = this.model.city.data.id;
		}
		this.citiesByCountry = cities.data;
	}

	async function loadFreeRooms(book, indexBooking, indexBookingRoom) {
		const numberMax = this.typeRooms.find(tr => tr.id === Number(book.entityId)).numberMax;
		const params = {
			dateInit: book.dateStart,
			dateEnd: book.dateEnd,
		};
		if (!!this.codeBooking && book.id) {
			params.roomId = book.id;
		}
		const { data: rooms } = await this.$http.get(`${process.env.PMS_URL}/roomtype/${this.subsidiaryId}/rooms/${book.entityId}`,
			{ params });
		this.bookings[indexBooking].rooms[indexBookingRoom].availableRooms = rooms.data;
		if (rooms.data.length === 0) {
			this.showNotification(
				'No se encontraron habitaciones para el tipo de habitación seleccionado.',
			'info',
		);
		}
		this.bookings[indexBooking].rooms[indexBookingRoom].maxQuantity = numberMax;
		this.bookings[indexBooking].rooms[indexBookingRoom].idRoom = 0;
		if (this.$route.query.roomId
			&& rooms.data.find(room => room.id === this.$route.query.roomId)) {
			this.bookings[indexBooking].rooms[indexBookingRoom].idRoom
				= Number(this.$route.query.roomId);
		}
		if (this.codeBooking) {
			const id = this.booking.room.data.length > 1
				? this.booking.room.data[indexBookingRoom].id : this.booking.room.data.id;
			this.bookings[indexBooking].rooms[indexBookingRoom].idRoom = id;
			this.bookings[indexBooking].rooms[indexBookingRoom].rateEdited
				= !!this.booking.summary.ratesPerDates[indexBookingRoom].rateEdited;
		}
	}

	async function loadRate({ bookings, loadService }, indexReservation, indexRoom) {
		const { id, entityId, checkIn, checkOut, adults, childs, idRoom } = bookings;
		this.bookings[indexReservation].rooms[indexRoom].numberNights = differenceInDays(
			checkOut,
			checkIn,
		);
		const params = { adults, childs, dateStart: checkIn, dateEnd: checkOut };
		const dateEndIsAfter = differenceInDays(checkOut, checkIn) > 0;
		if (this.codeBooking) {
			params.codeBooking = this.codeBooking;
		}
		if ((adults || childs) && dateEndIsAfter) {
			if (!this.codeBooking
				|| (checkIn !== format(this.booking.bookingStart, 'YYYY-MM-DD'))
				|| (checkOut !== format(this.booking.bookingEnd, 'YYYY-MM-DD'))
				|| (entityId !== this.booking.entityId)
				|| (idRoom !== this.booking.room.data.id)
				|| loadService) {
				try {
					const { data: rate } = await this.$http.get(`${process.env.PMS_URL}/rate/${this.subsidiaryId}/rooms/${entityId}`,
						{ params });
					const self = this;
					this.bookings[indexReservation].rooms
						= this.bookings[indexReservation].rooms.map((booking, index) => {
							const newBooking = { ...booking };
							if (index === indexRoom) {
								newBooking.rate = self.booking.summary.ratesPerDates &&
									!!self.codeBooking ? self.booking.summary.ratesPerDates[index].price :
									newBooking.rate || rate.data.price;
								newBooking.childs = newBooking.childs || 0;
							}
							return newBooking;
						});
				} catch (err) {
					const status = err.status;
					const message = err.data.message;
					if (status === 405) {
						if (message === 'ROOMTYPE_NOT_FOUND') {
							this.showNotification('El tipo de habitación seleccionado no cuenta con disponibilidad para la cantidad ingresada de personas.',
								'error');
							this.bookings = this.bookings.map((booking) => {
								const newBooking = { ...booking };
								if (booking.id === id) {
									newBooking.rate = 0;
								}
								return newBooking;
							});
						}
					} else if (status === 404) {
						if (message === 'BOOKING_NOT_AVAILABLE_RANGE') {
							this.showNotification('El tipo de habitación seleccionado no cuenta con disponibilidad para el rango de fechas seleccionado.',
								'error');
						}
						if (message === 'RACK_RATE_NOT_ENABLED') {
							this.showNotification('La tarifa rack de la habitación seleccionada se encuentra desactivada.',
								'error');
						}
					}
				} finally {
					this.bookings[indexReservation].rooms[indexRoom].total = this.totalByBooking(
						this.bookings[indexReservation].rooms[indexRoom],
					);
				}
			} else {
				this.bookings[indexReservation].rooms[indexRoom].total = this.totalByBooking(
					this.bookings[indexReservation].rooms[indexRoom],
				);
			}
		} else if (!dateEndIsAfter) {
			this.bookings = this.bookings.map((booking) => {
				const newBooking = { ...booking };
				if (booking.id === id) {
					newBooking.checkOut = null;
				}
				return newBooking;
			});
		} else {
			this.bookings[indexReservation].rooms[indexRoom].total = this.totalByBooking(
				this.bookings[indexReservation].rooms[indexRoom],
			);
		}
		this.checkIfNumberOfDayHasChanged(
			checkOut,
			checkIn,
			this.bookings[indexReservation].rooms[indexRoom],
		);
	}

	function checkIfNumberOfDayHasChanged(checkOut, checkIn, currentRooms) {
		const numberOfDays = differenceInDays(checkOut, checkIn);
		const currentNumberOfDays = differenceInDays(currentRooms.dateEnd, currentRooms.dateStart);
		if (numberOfDays !== currentNumberOfDays) {
			this.booking.bookingStart = checkIn;
			this.booking.bookingEnd = checkOut;
			this.loadRateByDayAndType(checkIn, checkOut);
		}
	}

	async function loadResources() {
		const request = [
			this.$http.get(`${process.env.PMS_URL}/hotel`),
			this.$http.get(`${process.env.PMS_URL}/countries`),
			this.$http.get(`${process.env.PMS_URL}/channels`),
			this.$http.get(`${process.env.PMS_URL}/sellers`),
			this.$http.get(`${process.env.PMS_URL}/documents-type`),
		];
		const [
			subsidiaries,
			countries,
			typeChannels,
			sellers,
			documentsType,
		] = await Promise.all(request);
		this.subsidiaries = subsidiaries.data.data;
		this.countries = countries.data.data;
		this.sellers = sellers.data.data;
		this.typeChannels = typeChannels.data.data;
		this.typeDocuments = documentsType.data.data;
		if (this.codeBooking) {
			this.loadBookingData();
		} else {
			this.subsidiaryId = this.$route.query.hotelId ? Number(this.$route.query.hotelId) :
				subsidiaries.data.data[0].id;
			this.typeChannelId = typeChannels.data.data[0].id;
			if (this.$route.query.endDate) {
				this.bookings[0].rooms[0] = this.setBookingsData(
					this.$route.query,
					this.bookings[0].rooms[0],
				);
			}
		}
	}

	function setBookingsData(query, roomsData) {
		const { initDate, endDate } = query;
		return compose(
			setNewProperty('checkIn', initDate),
			setNewProperty('checkOut', endDate),
			setNewProperty('currency', 'USD'),
			setNewProperty('numberNights', differenceInDays(
					endDate,
					initDate,
				),
			),
		)(roomsData);
	}

	async function loadRateByDayAndType(dateInit, dateEnd) {
		const freeUrl = `${process.env.PMS_URL}/roomtype/${this.subsidiaryId}/per-dates`;
		const params = {
			dateEnd,
			dateInit,
			numReserve: 1,
			roomTypeId: 194,
		};
		const { data: response } = await this.$http.get(freeUrl, { params });
		this.ratesByDayAndRoomType = response.data.footer.ratesPerDates;
	}

	async function loadTypeRooms(id) {
		const { data: roomtypes } = await this.$http.get(`${process.env.PMS_URL}/roomtype/${id}`);
		this.typeRooms = roomtypes.data;
		this.bookings = this.bookings.map((book, index) => {
			const newBook = { ...book };
			newBook.id = index + 1;
			newBook.adults = 0;
			newBook.childs = 0;
			newBook.currency = 'USD';
			newBook.entityId = 0;
			newBook.iconUpEnd = false;
			newBook.iconUpStart = false;
			newBook.idRoom = 0;
			newBook.maxQuantity = 0;
			newBook.menuEnd = false;
			newBook.menuStart = false;
			newBook.numberNights = 0;
			newBook.rate = 0;
			newBook.total = 0;
			newBook.numReservation = '';
			return newBook;
		});
		if (this.$route.query.roomTypeId) {
			this.bookings[0].rooms[0].entityId = Number(this.$route.query.roomTypeId);
		}
		if (this.codeBooking) {
			const rooms = this.booking.room.data.length
			? this.booking.room.data
			: [this.booking.room.data];
			this.bookings[0].rooms = map(
				setNewPropertyByFunction('entityId', getRatePerDates('entityId', this.booking), false),
				rooms,
			);
			this.bookings[0].rooms.forEach((room, index) => this.loadFreeRooms(room, 0, index));
			this.bookings[0].rooms = this.buildRooms(this.bookings[0].rooms, this.booking);
			this.bookings[0].numReservation = this.booking.numReservation;
		}
		const roomTypeId = Number(this.$route.query.roomTypeId) || Number(this.booking.entityId);
		const roomtypeSelected = find(equality('id', roomTypeId), this.typeRooms);
		this.arrayEarly = [...roomtypeSelected.earlyCheckin];
		this.arrayLate = [...roomtypeSelected.lateCheckout];
	}

	function nameLabel() {
		return this.isNaturalPerson ? 'Nombres' : 'Razón Social';
	}

	function nameMessage() {
		return this.isNaturalPerson ? 'El nombre es requerido' : 'La razón social es requerida';
	}

	function numDocumentLength() {
		if (this.model.documentType === 1) {
			return 8;
		} else if (this.model.documentType === 4) {
			return 11;
		}
		return 0;
	}

	function roomsAreEmpty() {
		return this.rooms.length === 0;
	}

	function getCustomerData(customer) {
		const { id, ruc } = customer;
		let model = {};
		let dateBirth = '';
		if (id) {
			model = { ...customer };
			const countryId = customer.country && customer.country.data ? customer.country.data.id
				: `${process.env.DEFAULT_COUNTRY_ID}`;
			dateBirth = customer.dateBirth && isDate(new Date(customer.dateBirth))
				? customer.dateBirth : this.dateBirth;
			model = compose(
				setNewProperty('countryId', countryId),
				setNewProperty('dateBirth', dateBirth),
				setNewProperty('flagRate', false),
			)(model);
			if (model.flagLoyalty === 1) {
				this.showCheckLoyalty = false;
			}
		}
		if (ruc) {
			dateBirth = customer.fecha_inscripcion
				&& customer.fecha_inscripcion !== '0000-00-00'
				&& isDate(new Date(customer.fecha_inscripcion))
				? customer.fecha_inscripcion : this.dateBirth;
			model = compose(
				setNewProperty('address', customer.domicilio),
				setNewProperty('cardVip', ''),
				setNewProperty('cityId', 0),
				setNewProperty('civilStatus', 0),
				setNewProperty('countryId', process.env.DEFAULT_COUNTRY_ID),
				setNewProperty('dateBirth', dateBirth),
				setNewProperty('documentType', 4),
				setNewProperty('email', ''),
				setNewProperty('flagLoyalty', false),
				setNewProperty('flagTaxes', false),
				setNewProperty('gender', 0),
				setNewProperty('lastname', ''),
				setNewProperty('name', customer.nombre),
				setNewProperty('numDocument', customer.ruc),
				setNewProperty('phone', customer.phone),
			)(model);
		}
		return model;
	}

	async function searchCustomer() {
		let customer = {};
		if (this.model.numDocument !== '') {
			if (this.model.documentType === 4) {
				try {
					const url = `${process.env.PMS_URL}/customer-search`;
					const params = {
						numDocument: this.model.numDocument,
						documentType: this.model.documentType,
					};
					(
						{ data: customer } = await this.$http.get(url, { params })
					);
				} catch (error) {
					customer = {};
					this.showNotification('La empresa no se encuentra registrada como cliente', 'warning');
				}
			}
			try {
				if (!customer.data) {
					(
						{ data: customer } = await this.mixinSearchCustomer(
							this.model.documentType,
							this.model.numDocument,
						)
					);
				}
				if (customer.data) {
					this.model = this.getCustomerData(customer.data);
					this.model.flagGeneric = false;
					if (!this.model.flagTaxes) {
						this.$set(this.model, 'flagTaxes', false);
					}
					this.showNotification('Cliente conseguido !', 'success');
				}
			} catch (error) {
				if (this.model.documentType === 4) {
					this.showNotification('La empresa no se encuentra registrada como cliente', 'warning');
				} else {
					this.showNotification('La persona no se encuentra registrada como cliente', 'warning');
				}
				const numDocument = this.model.numDocument;
				const currentDocumentType = this.model.documentType;
				const flagGeneric = this.model.flagGeneric;
				this.model = this.defaultModel();
				this.model.numDocument = numDocument;
				this.model.documentType = currentDocumentType;
				this.model.flagGeneric = flagGeneric;
				this.model.countryId = process.env.DEFAULT_COUNTRY_ID;
			}
		}
	}

	function defaultModel() {
		return {
			address: '',
			cardVip: '',
			cityId: 0,
			civilStatus: 1,
			countryId: 0,
			dateBirth: this.dateBirth,
			documentType: 1,
			email: '',
			flagGeneric: false,
			flagLoyalty: false,
			flagRate: false,
			flagTaxes: false,
			gender: 1,
			id: null,
			lastname: '',
			name: '',
			numDocument: '',
			phone: '',
		};
	}

	function setChannelInfo(id) {
		this.showCustomerRate(this.subsidiaryId);
		if (id > 0) {
			const channel = this.channels.find(c => c.id === id);
			if (!this.codeBooking) {
				if (channel) {
					this.typeChannelSelected.fields = this.typeChannelSelected.fields.map((field) => {
						const newField = { ...field };
						newField[field.value] = channel.informations[field.value] ?
							channel.informations[field.value] : '';
						return newField;
					});
				}
			} else {
				const channelInformations = this.booking.channel ?
					this.booking.channel.data.questions : {};
				this.typeChannelSelected.fields = this.typeChannelSelected.fields.map((field) => {
					const newField = { ...field };
					newField[field.value] = channelInformations[field.value]
						|| channel.informations[field.value] || '';
					return newField;
				});
			}
		}
	}

	function subDaysMethod(date, days) {
		return subDays(date, days);
	}

	function subtotalAmount() {
		return this.bookings.reduce(
			(acum, book) => acum + book.rooms.reduce(
				(acc, room) => acc + Number(room.total), 0,
			),
		0);
	}

	function taxes() {
		const hotel = this.subsidiaries.find(sub => sub.id === this.subsidiaryId);
		const taxArray = hotel && hotel.taxes ? hotel.taxes : [];
		return taxArray;
	}

	function taxesAmount() {
		const taxesValue = this.taxes.reduce((acum, tax) => acum + (Number(tax.amount) / 100), 0);
		const bookingsLength = this.bookings.length;
		const taxesCalculate = taxesValue * bookingsLength;
		const totalTaxes = this.subtotalAmount * taxesCalculate;
		return this.model.flagTaxes ? 0 : totalTaxes;
	}

	function totalAmount() {
		return this.subtotalAmount + this.taxesAmount;
	}

	function totalByBooking({ numberNights, rate }) {
		return Number(rate) * Number(numberNights);
	}

	function validateNumReservation({ id }) {
		const bookingValid = this.bookings.find(book => book.id === id) || {};
		const bookingIndex = this.bookings.findIndex(b => b.id === id);
		const validArray = bookingValid.numReservation.split('');
		const slash = validArray.filter(v => v === '/');
		const slashLength = slash.length;
		const valid = slashLength === 1;
		if ((bookingIndex > -1) && (validArray.length > 0) && !valid) {
			this.bookings[bookingIndex].invalid = true;
		} else {
			this.bookings[bookingIndex].invalid = false;
		}
		return valid;
	}

	function validations() {
		const model = {
			documentType: {
				required: requiredIf(() => this.genericCustomer),
			},
			lastname: {
				required: requiredIf(() => this.genericCustomer && this.isNaturalPerson),
			},
			name: {
				required: requiredIf(() => this.genericCustomer),
			},
			numDocument: {
				required: requiredIf(() => this.genericCustomer),
			},
		};
		if (this.numDocumentLength > 0) {
			model.numDocument.maxLength = maxLength(this.numDocumentLength);
			model.numDocument.minLength = minLength(this.numDocumentLength);
		}
		return { model };
	}

	async function showCustomerRate(value) {
		try {
			const baseUrl = process.env.PMS_URL;
			const params = {
				channelInformationsId: this.channelSelected,
			};
			const { data: tarifarioSelect } = await this.$http.get(`${baseUrl}/customers/${FLAG_RATE}/rates/${value}`, { params });
			this.rateAvailability = tarifarioSelect.data;
			this.flagBooking = true;
		} catch (err) {
			if (err.data.message === 'BOOKING_CODE_EXISTS') {
				this.showNotification('Tipo de reserva no reconocido', 'error');
			} if (err.data.message === 'CHANNEL_NOT_FOUND') {
				this.showNotification('Tipo de chanel no reconocido', 'error');
			} if (err.data.message === 'CUSTOMER_NOT_TYPE_COMERCIAL') {
				this.showNotification('No registrado como cliente comercial', 'error');
				this.flagBooking = false;
			}
		}
	}

	function onShowRateModal() {
		this.flagShowRateModal = !this.flagShowRateModal;
	}

	function updateCustomerRate(roomData) {
		this.bookings[0].rate = roomData.rateAvailability[1];
		this.totalByBooking(this.bookings[0]);
	}

	function multipleBookings() {
		return this.bookings.length > 1;
	}

	function editReservation(open, index) {
		const roomsByDay = this.buildRoomsByDay(this.bookings[index], index);
		this.insertListRoomsAndOpenModal(roomsByDay, open);
	}

	function insertListRoomsAndOpenModal(roomsByDay, open) {
		const self = this;
		const newRoomsByDay = [...roomsByDay];
		const listRoomsRequests = map(this.getListRooms(), roomsByDay);
		Promise.all(listRoomsRequests)
		.then((response) => {
			response.forEach((item, index) => {
				newRoomsByDay[index].listRooms = item.data.data;
			});
			self.roomsByDay = [[...newRoomsByDay]];
			self.roomsModalOpen = open;
		});
	}

	function getListRooms() {
		const self = this;
		return function inner(item) {
			const roomTypeId = item.roomTypeId;
			const currentDate = item.dateReservation;
			const nextDate = formatDate(addDays(currentDate, 1), 'YYYY-MM-DD');
			const url = `${process.env.PMS_URL}/roomtype/${self.subsidiary}/rooms/${roomTypeId}`;
			const params = {
				dateInit: currentDate,
				dateEnd: nextDate,
				roomId: item.idRoom,
			};
			return self.$http.get(url, { params });
		};
	}

	function closeModal(value) {
		this.roomsModalOpen = value;
	}

	function inRangeDate(currentDay) {
		return function inner(item) {
			const startDate = item.checkIn;
			const endDate = item.checkOut;
			return isWithinRange(currentDay, startDate, endDate) && isBefore(currentDay, endDate);
		};
	}

	function buildRoomsByDay(booking, indexReservation) {
		const { rooms } = booking;
		const initDate = rooms[0].checkIn;
		const leng = rooms.length;
		const endDate = rooms[leng - 1].checkOut;
		const totalDays = differenceInDays(endDate, initDate);
		const arrayOfDates = [];
		if (leng > 1) {
			for (let i = 0; i < totalDays; i += 1) {
				const currentDay = formatDate(addDays(initDate, i), 'YYYY-MM-DD');
				const room = find(this.inRangeDate(currentDay), rooms);
				arrayOfDates.push(room);
			}
			return reduce(this.getDataForEachDay(indexReservation, initDate), arrayOfDates);
		}
		for (let i = 1; i <= totalDays; i += 1) {
			arrayOfDates.push(rooms[0]);
		}
		return reduce(this.getDataForEachDay(indexReservation, initDate), arrayOfDates);
	}

	function getDataForEachDay(indexReservation, initDate) {
		return function inner(list, item, index) {
			const room = compose(
				setNewProperty('days', index + 1),
				setNewProperty('roomTypeId', item.entityId),
				setNewProperty('idRoom', item.idRoom),
				setNewProperty('dateReservation', formatDate(addDays(initDate, index), 'YYYY-MM-DD')),
				setNewProperty('rate', Number(item.rate)),
				setNewProperty('indexReservation', Number(indexReservation)),
				setNewProperty('rateEdited', !!item.rateEdited),
			)({});
			return list.concat(room);
		};
	}

	function formattingDate(date) {
		let newDate = '';
		if (date) {
			newDate = formatDate(date, 'YYYY-MM-DD');
		}
		return newDate;
	}

	function updatingRoomsData(roomsByDay) {
		return function inner(item, index) {
			const current = roomsByDay[0][index];
			return compose(
				setNewProperty('numberNights', 1),
				setNewProperty('idRoom', current.idRoom),
				setNewProperty('rate', current.rate),
				setNewProperty('entityId', current.roomTypeId),
				setNewProperty('rateEdited', current.rateEdited),
			)(item);
		};
	}

	function updateReservation(roomsByDay) {
		const index = roomsByDay[0][0].indexReservation;
		const firstRoom = roomsByDay[0][0].idRoom;
		const isOnlyOneRoom = roomsByDay[0].every(r => r.idRoom === firstRoom);
		const originalRoomsQuantity = this.bookings[index].rooms.length;
		if (!isOnlyOneRoom && originalRoomsQuantity === 1) {
			this.convertToMultiRoomsReservation(roomsByDay, index);
		} else if (isOnlyOneRoom && originalRoomsQuantity > 1) {
			this.convertInOneRoomsReservation(roomsByDay, index);
		} else {
			this.updateMultiRoomsReservation(roomsByDay, index);
		}
		this.closeModal();
	}

	function updateRoomsSelected(value) {
		this.roomsByDay = [...value];
	}

	function multiRooms() {
		const rooms = this.bookings[0].rooms.length === 1;
		const bookingRooms = this.booking.room && !this.booking.room.data.length;
		return rooms && bookingRooms;
	}

	function convertInOneRoomsReservation(roomsByDay, index) {
		const totalDays = roomsByDay[0].length;
		let rooms = [];
		const dateInit = roomsByDay[0][0].dateReservation;
		for (let i = 0; i < totalDays; i += 1) {
			const newRoomReservation = { ...this.bookings[0].rooms[0] };
			newRoomReservation.checkIn = format(addDays(dateInit, i), 'YYYY-MM-DD');
			newRoomReservation.checkOut = format(addDays(dateInit, i + 1), 'YYYY-MM-DD');
			newRoomReservation.entityId = roomsByDay[0][0].roomTypeId;
			newRoomReservation.idRoom = roomsByDay[0][0].idRoom;
			newRoomReservation.rate = roomsByDay[0][0].rate;
			newRoomReservation.numberNights = totalDays;
			newRoomReservation.total = newRoomReservation.rate * totalDays;
			rooms = rooms.concat(newRoomReservation);
		}
		this.bookings[index].rooms = [...rooms];
	}

	function updateMultiRoomsReservation(roomsByDay, index) {
		this.bookings[index].rooms = map(
			this.updatingRoomsData(roomsByDay),
			this.bookings[index].rooms,
		);
	}

	function convertToMultiRoomsReservation(roomsByDay, index) {
		const numberOfDays = roomsByDay[0].length;
		let provisionalArray = [];
		const originalRoom = { ...this.bookings[index].rooms[0] };
		for (let i = 0; i < numberOfDays; i += 1) {
			originalRoom.checkIn = roomsByDay[0][i].dateReservation;
			originalRoom.checkOut = formatDate(
				addDays(originalRoom.checkIn, 1),
				'YYYY-MM-DD',
			);
			originalRoom.entityId = roomsByDay[0][i].roomTypeId;
			originalRoom.ratesPerDates.entityId = roomsByDay[0][i].roomTypeId;
			originalRoom.availableRooms = roomsByDay[0][i].listRooms;
			originalRoom.idRoom = 0;
			originalRoom.ratesPerDates.roomId = roomsByDay[0][i].idRoom;
			originalRoom.rate = roomsByDay[0][i].rate;
			originalRoom.numberNights = differenceInDays(
				originalRoom.checkOut,
				originalRoom.checkIn,
			);
			originalRoom.total = originalRoom.numberNights * Number(originalRoom.rate);
			const newOriginalRoom = { ...originalRoom };
			newOriginalRoom.ratesPerDates = { ...originalRoom.ratesPerDates };
			provisionalArray = provisionalArray.concat(newOriginalRoom);
		}
		this.bookings[index].rooms = [...provisionalArray];
		this.booking.summary.ratesPerDates = map(
			this.updateBooking(this.booking.summary.ratesPerDates),
			roomsByDay[0],
		);
		this.bookings[index].rooms.forEach((r, indexR) => this.loadFreeRooms(r, index, indexR));
	}

	function updateBooking(ratesPerDates) {
		return function inner(item) {
			return compose(
				setNewProperty('roomId', item.idRoom),
				setNewProperty('rate', Number(item.rate)),
				setNewProperty('price', Number(item.rate)),
				setNewProperty('currency', ratesPerDates[0].currency),
				setNewProperty('entityId', item.roomTypeId),
				setNewProperty('iso_currency', ratesPerDates[0].iso_currency),
				setNewProperty('rack', ratesPerDates[0].rack),
				setNewProperty('rate_id', ratesPerDates[0].rate_id),
				setNewProperty('type_discount', ratesPerDates[0].type_discount),
			)(item);
		};
	}

	function updateTotalByBooking(booking, indexReservation, indexRoom) {
		this.bookings[indexReservation].rooms[indexRoom].total = this.totalByBooking(
			this.bookings[indexReservation].rooms[indexRoom],
		);
	}

	function headerDates() {
		return {
			initDate: format(this.booking.bookingStart, 'YYYY-MM-DD'),
			endDate: format(this.booking.bookingEnd, 'YYYY-MM-DD'),
		};
	}

	function lateCheckOutIsSelected() {
		return !!this.lateCheckOut;
	}

	function earlyCheckInIsSelected() {
		return !!this.earlyCheckIn;
	}

	function selectBed(value) {
		this.bedSelected = value;
	}

	function selectCrib(value) {
		this.cribSelected = value;
	}

	function getExtraBed(price) {
		return {
			id: 1,
			quantity: 1,
			flag: 1,
			price,
		};
	}

	function getCrib(price) {
		return {
			id: 2,
			quantity: 1,
			flag: 1,
			price,
		};
	}

	function getServicesPrices(services) {
		services.forEach((service) => {
			if (service.code === 'EXTRABEG') {
				this.bedSelected = true;
				this.aditionalBedPrice = service.price;
				this.disabledBed = true;
			}
			if (service.code === 'CRIB') {
				this.cribSelected = true;
				this.cribPrice = service.price;
				this.disabledCrib = true;
			}
		});
	}

	function checkForEarlyCheckInAndLateCheckOut(booking) {
		const opt = {
			earlyCheckIn: 'arrayEarly',
			lateCheckOut: 'arrayLate',
		};
		['earlyCheckIn', 'lateCheckOut'].forEach((flag) => {
			const exist = getDeeper('summary', flag)(booking);
			if (exist) {
				this[opt[flag]] = this[opt[flag]].map((item) => {
					const newItem = { ...item };
					if (item.id === booking.summary[flag].id) {
						newItem.hour = getDeeper('summary', flag, 'hour')(booking);
						newItem.price = getDeeper('summary', flag, 'price')(booking) || 0;
					}
					return newItem;
				});
				this[flag] = find(equality('id', booking.summary[flag].id), this[opt[flag]]);
				if (flag === 'earlyCheckIn') {
					this.earlyCheckinDisabled = true;
				} else {
					this.lateCheckOutDisabled = true;
				}
			}
		});
	}
	
	function updateRatesInReservation(rates) {
		this.roomsByDay[0] = [...rates];
	}

	function breakItByDay({ rooms }) {
		const enterDay = rooms[0].checkIn;
		const len = rooms.length;
		const outDay = rooms[len - 1].checkOut;
		const diff = differenceInDays(outDay, enterDay);
		let roomsList = [];
		for (let i = 0; i < diff; i += 1) {
			const initDate = format(addDays(enterDay, i), 'YYYY-MM-DD');
			const endDate = format(addDays(initDate, 1), 'YYYY-MM-DD');
			const index = rooms.findIndex((r) => {
				const { checkIn, checkOut } = r;
				return checkOut === initDate ? false : isWithinRange(initDate, checkIn, checkOut);
			});
			const room = compose(
				setNewProperty('checkIn', initDate),
				setNewProperty('checkOut', endDate),
			)(rooms[index]);
			roomsList = roomsList.concat(room);
		}
		return roomsList;
	}

	function data() {
		return {
			flagBooking: false,
			aditionalBedPrice: '20.00',
			arrayEarly: [
				{ id: 1, flag: 1, price: '', hour: '' },
				{ id: 2, flag: 1, price: '', hour: '' },
				{ id: 3, flag: 1, price: '', hour: '' },
			],
			arrayLate: [
				{ id: 1, flag: 1, price: '', hour: '' },
				{ id: 2, flag: 1, price: '', hour: '' },
				{ id: 3, flag: 1, price: '', hour: '' },
			],
			bedSelected: false,
			birthDateIcon: false,
			bookings: [
				{
					id: 1,
					adults: 0,
					checkIn: null,
					checkOut: null,
					childs: 0,
					currency: 'USD',
					entityId: 0,
					iconUpEnd: false,
					iconUpStart: false,
					idRoom: 0,
					maxQuantity: 0,
					menuEnd: false,
					menuStart: false,
					numberNights: 0,
					numReservation: '',
					rate: 0,
					ratesByDayAndRoomType: {},
					rooms: [
						{
							availableRooms: [],
							idRoom: 0,
							entityId: 0,
						},
					],
					total: 0,
				},
			],
			booking: {
				channel: { data: {} },
				customer: { data: { country: { data: {} } } },
				room: {
					data: [
						{
							roomTypes: {
								data: {},
							},
						},
					],
				},
				summary: {
					amounts: {},
					booking: {},
					personalInformation: {},
					promotion: {},
				},
			},
			channels: [],
			channelSelected: 0,
			checkinActive: false,
			citiesByCountry: [],
			civilStatus: [
				{ id: 1, name: 'Soltero(a)' },
				{ id: 2, name: 'Casado(a)' },
				{ id: 3, name: 'Viudo(a)' },
				{ id: 4, name: 'Divorciado(a)' },
			],
			countries: [],
			cribPrice: '20.00',
			cribSelected: false,
			currencies: [{ id: 1, code: 'USD', name: 'Dólares' }],
			dateBirth: format(subYears(new Date(), 18), 'YYYY-MM-DD'),
			disabledBed: false,
			disabledCrib: false,
			earlyCheckIn: null,
			earlyCheckinDisabled: false,
			flagCheckIn: false,
			flagShowRateModal: false,
			formatted: null,
			genders: [
				{ id: 1, name: 'Hombre' },
				{ id: 2, name: 'Mujer' },
			],
			invalid: false,
			lateCheckOut: null,
			lateCheckOutDisabled: false,
			menuBirthDate: false,
			model: {
				address: '',
				cardVip: '',
				cityId: 0,
				civilStatus: 1,
				countryId: 0,
				dateBirth: format(subYears(new Date(), 18), 'YYYY-MM-DD'),
				documentType: 0,
				email: '',
				flagGeneric: false,
				flagLoyalty: false,
				flagRate: false,
				flagTaxes: false,
				gender: 1,
				id: null,
				lastname: '',
				name: '',
				numDocument: '',
				phone: '',
			},
			multiBookings: {},
			rateAvailability: [],
			rooms: [],
			roomsByDay: [],
			roomsModalOpen: false,
			sellers: [],
			sellerId: 0,
			showAditionalBook: false,
			showCheckLoyalty: true,
			specialRequest: '',
			subsidiaries: [],
			subsidiaryId: 0,
			typeCard: 1,
			typeCards: [{ id: 1, name: 'VIP' }],
			typeChannelId: 0,
			typeChannels: [],
			typeChannelSelected: {
				id: 1,
				fields: [],
			},
			typeDocuments: [],
			typeRooms: [],
			prepaymentDisabled: false,
		};
	}

	export default {
		name: 'booking-new',
		components: {
			ButtonCreate,
			ButtonField,
			DateHeader,
			rateModal,
			roomsComponent,
			selectButton,
			SelectDate,
			SelectRoomNumber,
		},
		computed: {
			bookingDisabled,
			btnText,
			channelEmpty,
			disabledBtnCreate,
			earlyCheckInIsSelected,
			genericCustomer,
			headerDates,
			isNaturalPerson,
			lateCheckOutIsSelected,
			multipleBookings,
			nameLabel,
			nameMessage,
			numDocumentLength,
			multiRooms,
			roomsAreEmpty,
			subtotalAmount,
			taxes,
			taxesAmount,
			totalAmount,
		},
		created,
		data,
		filters: {
			parseDate,
			round,
		},
		methods: {
			showCustomerRate,
			addBookingRow,
			arrowIcon,
			basicReservationCreate,
			basicReservationEdit,
			breakItByDay,
			buildRooms,
			buildRoomsByDay,
			changeFormatDate,
			changeIcon,
			checkForEarlyCheckInAndLateCheckOut,
			checkIfNumberOfDayHasChanged,
			closeModal,
			convertInOneRoomsReservation,
			convertToMultiRoomsReservation,
			createBooking,
			defaultModel,
			deleteBooking,
			editReservation,
			formatBooking,
			formattingDate,
			getCrib,
			getExtraBed,
			getCustomerData,
			getDataForEachDay,
			getListRooms,
			getServicesPrices,
			getSummaryData,
			goToCheckIn,
			inRangeDate,
			insertListRoomsAndOpenModal,
			isAfterMethod,
			loadBookingData,
			loadChannels,
			loadCities,
			loadFreeRooms,
			loadRate,
			loadRateByDayAndType,
			loadResources,
			loadTypeRooms,
			multipleReservation,
			onShowRateModal,
			searchCustomer,
			selectBed,
			selectCrib,
			setBookingsData,
			setChannelInfo,
			simpleReservation,
			subDaysMethod,
			totalByBooking,
			updateBooking,
			updateCustomerRate,
			updateMultiRoomsReservation,
			updateRatesInReservation,
			updateReservation,
			updateRoomsSelected,
			updateTotalByBooking,
			updatingRoomsData,
			validateNumReservation,
		},
		mixins: mixin,
		props: {
			codeBooking: {
				type: String,
			},
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.bar-data {
		align-items: center;
		background-color: white;
		box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
		display: flex;
		height: 48px;
		justify-content: space-around;

		&-item {
			border-right: 1px solid map-get($colors, year-select);
			flex: 1 auto;

			&:last-of-type {
				border-right: 0px;
			}

			&.no-border {
				border-right: 0px;
			}

			p {
				color: map-get($colors, bg-chart);
				font-family: map-get($fonts, medium);
				font-size: map-get($sizes, fourteen);
				margin-bottom: 0px;

				span {
					color: map-get($colors, realtime-label);
					font-family: map-get($fonts, regular);
					font-size: map-get($sizes, fourteen);
				}
			}
		}

		.bar-icon {
			font-size: map-get($map: $sizes, $key: twenty);
			justify-content: flex-start;
			width: 20px;
		}
	}

	.border-right {
		border-right: 1px solid map-get($colors, e-bg-icon);
	}

	.label-form.small {
		font-size: map-get($sizes, twelve);
	}

	.col-without-label {
		padding-bottom: 0px !important;
		padding-top: 25.4px !important;
	}

	.btn-option {
		min-width: auto;
		width: auto;
	}

	.label-title {
		color: map-get($colors, dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, fourteen);
	}

	.number-nights {
		vertical-align: middle;
	}

	.total-amount {
		color: map-get($colors, dark);

		p {
			font-family: map-get($fonts, bold);
			font-size: map-get($sizes, fourteen);
			margin: 0px;
		}

		span {
			font-family: map-get($fonts, semibold);
			font-size: map-get($sizes, maintitle);
		}
	}

	.code-number {
		color: map-get($colors, blue-title);
		font-family: map-get($fonts, semibold);
	}

	.generic-checkbox {
		width: 140px;

		&:hover:before {
			transform: translate3d(14px,7px,0) scale(1);
		}
	}

	.customer-rate {
		position: relative;

		.rate-modal {
			bottom: 95%;
			position: absolute;
			right: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// New.vue?84199d02